import { httpCreate } from './http';

const http = httpCreate('/srv/activity-watch-award');
// 观看奖励
export const activityWatchAward = {
	// PC端获取列表
	getList(activityId, params) {
		return http.get(`/list/${activityId}`, { params });
	},
	// 新增奖励
	create(activityId, data, params) {
		return http.post('', data, { params });
	},
	// 修改观看奖励 修改观看奖励。该接口不允许更改与支付相关的信息（包含字段：type（0-普通红包 1-拼手气红包）、amount（红包总金额）、count（红包个数））
	editor(awardId, data) {
		return http.post(`/${awardId}`, data);
	},
	// 根据id获取观看奖励详情
	getInfoById(awardId) {
		return http.get(`/${awardId}`);
	},
	// 关闭/打开观看奖励
	statusChange(awardId) {
		return http.post(`/status/${awardId}`);
	},
	// 退款
	refund(awardId) {
		return http.post(`/refund/${awardId}`);
	},
	// 领取列表
	receiveList(awardId, params) {
		return http.get(`/receive/list/${awardId}`, { params });
	},
	receiveActivityList(activityId, params) {
		return http.get(`/receive/list-activity/${activityId}`, { params });
	},
	// 活动列表-id列表
	allIdList(activityId) {
		return http.get(`/all/${activityId}`);
	},
	// 核销
	verdict(awardId, data) {
		return http.put(`/verdict/${awardId}`, data);
	},
};
